import {
  fetchStudentClassModule,
  fetchSubModuleTree,
  fetchSubModuleDetail,
  studentAnswerQuestion,
  studentEndSubModuleSession,
  fetchStudentWrongQuestions,
  practiceEnrollSingleItem,fetchPdfList,
  practiceEnrollmentUpdateType,
  emgInsertResultData,
  EmgInsertResultDataBody,
  EmgInsertResultFallbackMeta,
} from "@store/actions/studentPracticeAction"
import { AppState, AppDispatch } from '../store';
import { useDispatch, useSelector } from "react-redux";
import { resetStudentPracticeData, resetPracticeEnrollData, setCurrentQuestionList, setCurrentModulePractice, resetEmgInsertResultData } from "@store/reducers/studentPracticeReducer";

export const useStudentPractice = () => {
  const studentClassModuleList = useSelector((state: AppState) => state.studentPractice.studentClassModuleList)
  const subModuleTree = useSelector((state: AppState) => state.studentPractice.subModuleTree)
  const subModuleDetail = useSelector((state: AppState) => state.studentPractice.subModuleDetail)
  const studentWrongQuestions = useSelector((state: AppState) => state.studentPractice.studentWrongQuestionResult)
  const loading = useSelector((state: AppState) => state.studentPractice.loading)
  const sesstionSubmoduleResult = useSelector((state: AppState) => state.studentPractice.sesstionSubmoduleResult)
  const practiceEnrollSuccess = useSelector((state: AppState) => state.studentPractice.practiceEnrollSuccess)
  const practiceEnrollLoading = useSelector((state: AppState) => state.studentPractice.practiceEnrollLoading)
  const currentQuestionList = useSelector((state: AppState) => state.studentPractice.currentQuestionList)
  const currentModulePractice = useSelector((state: AppState) => state.studentPractice.currentModulePractice)
  const pdfList = useSelector((state: AppState) => state.studentPractice.pdfList)
  const loadingPdfList = useSelector((state: AppState) => state.studentPractice.loadingPdfList)
  const emgInsertResultLoading = useSelector((state: AppState) => state.studentPractice.emgInsertResultLoading)
  const emgInsertResultSuccess = useSelector((state: AppState) => state.studentPractice.emgInsertResultSuccess)
  const emgInsertResultResponse = useSelector((state: AppState) => state.studentPractice.emgInsertResultData)
  const dispatch: AppDispatch = useDispatch();

  const fetchStudentClassModuleAction = (type?: number) => {
    dispatch(fetchStudentClassModule(type))
  }

  const fetchSubModuleTreeAction = (moduleId: string, classId: string, practice_type?: number) => {
    console.log('fetchhhhhhhh')
    dispatch(fetchSubModuleTree(moduleId, classId, practice_type))
  }

  const resetStudentPracticeDataAction = () => {
    dispatch(resetStudentPracticeData())
  }

  const fetchSubModuleDetailAction = (subModuleId: string, classId: string) => {
    dispatch(fetchSubModuleDetail(subModuleId, classId))
  }
  const fetchPdfListAction = (subModuleId: string, classId: string) => {
    dispatch(fetchPdfList(subModuleId, classId))
  }
  const studentAnswerQuestionAction = (questionId: string) => {
    dispatch(studentAnswerQuestion(questionId))
  }

  const studentEndSubModuleSessionAction = (sessionId: string) => {
    dispatch(studentEndSubModuleSession(sessionId))
  }

  const fetchStudentWrongQuestionsAction = (sessionId: string) => {
    dispatch(fetchStudentWrongQuestions(sessionId))
  }

  const practiceEnrollSingleItemAction = (data: practiceEnrollmentUpdateType): void => {
    dispatch((practiceEnrollSingleItem as any)(data))
  }

  const resetPracticeEnrollDataAction = () => {
    dispatch(resetPracticeEnrollData())
  }

  const setCurrentQuestionListAction = (data: any) => {
    dispatch(setCurrentQuestionList(data))
  }

  const setCurrentModulePracticeAction = (data: any) => {
    dispatch(setCurrentModulePractice(data))
  }

  const emgInsertResultDataAction = (
    data: EmgInsertResultDataBody,
    meta: EmgInsertResultFallbackMeta,
  ) => {
    dispatch(emgInsertResultData({ data, meta }))
  }

  const resetEmgInsertResultDataAction = () => {
    dispatch(resetEmgInsertResultData())
  }

  return {
    fetchStudentClassModuleAction,
    studentClassModuleList,
    fetchSubModuleTreeAction,
    resetStudentPracticeDataAction,
    fetchSubModuleDetailAction,
    studentAnswerQuestionAction,
    studentEndSubModuleSessionAction,
    fetchStudentWrongQuestionsAction,
    studentWrongQuestions,
    sesstionSubmoduleResult,
    subModuleTree,
    subModuleDetail,
    loading,
    practiceEnrollSuccess,
    practiceEnrollLoading,
    practiceEnrollSingleItemAction,
    resetPracticeEnrollDataAction,
    setCurrentQuestionListAction,
    currentQuestionList,
    setCurrentModulePracticeAction,
    currentModulePractice,
    fetchPdfListAction,
    pdfList,
    loadingPdfList,
    emgInsertResultDataAction,
    resetEmgInsertResultDataAction,
    emgInsertResultLoading,
    emgInsertResultSuccess,
    emgInsertResultResponse,
  }

}